<div class="d-flex flex-column flex-xl-row busy-overlay-parent" [ngClass]="loading&&'disabled'">
  <div *ngIf="loading" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <div class="d-flex flex-fill" style="max-width:100%;overflow-x:auto;">
    <div class="w-100">
    <div class="mx-4 mt-4 mb-2 p-2 card" *ngIf="volunteerTaskPoint">
      <div id="printableVolunteerPoint">
        <table class="table table-sm mb-1">
          <tr>
            <th>Common Name</th>
            <td>
              <button class="p-0 btn btn-link" title="Edit Title"
                *ngIf="!commonName.bEditing; else editingCommonNameTmpl"
                (click)="commonName.beginEdit()">
                {{volunteerTaskPoint.commonName}}
                <i class="noprint fa fa-edit mx-2"></i>
              </button>
              <ng-template #editingCommonNameTmpl>
                <div class="d-flex flex-row mr-1">
                  <input type="text" class="form-control" autofocus
                    (keyup.enter)="onSaveCommonName()"
                    [(ngModel)]="commonName.value" #commonNameInput="ngModel">
                  <span class="ml-1 text-nowrap" style="width: 3em">
                  <i *ngIf="commonNameInput.dirty" title="Save Common Name"
                    class="text-primary fa fa-save p-1 mx-1 border" role="button"
                    (click)="onSaveCommonName()"></i>
                  <i title="Cancel Edit" class="text-danger fa fa-times p-1 mx-1 border" role="button"
                    (click)="commonName.reset()"></i>
                  </span>
                </div>
                <div *ngIf="commonName.errorMsg" class="text-danger font-italic font-weight-bold">
                  {{commonName.errorMsg}}
                </div>
              </ng-template>
            </td>
          </tr>
          <tr *ngFor="let attrDef of demoAttrDefs">
              <th>{{ attrDef.title }}</th>
              <td>{{ volunteerTaskPoint[attrDef.attr] }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td class="pl-0">
              <div class="d-flex flex-row">
              <select id="status-select" class="text-center align-middle mx-1 p-0 border-none"
                  [(ngModel)]="status.value"
                  [ngClass]="status.value|taskStatusCss"
                  (change)="onSaveInlineEdit(status)">
                <option  class="status-not-started-text" value="1">Not Started</option>
                <option class="status-in-progress-text" value="2">In Progress</option>
                <option class="status-approved-text" value="3">Complete</option>
                <option class="status-field-complete-text" value="4">Field Complete</option>
                <option [hidden]="!this.roleMgr.canEditUsers" class="status-review-complete-text" value="5">Review Complete</option>
                <option [hidden]="!this.roleMgr.canEditUsers" class="status-not-using-text" value="6">Not Using</option>
                <option [hidden]="!this.roleMgr.canEditUsers" class="status-archived-text" value="7">Archived</option>
              </select>
              <span class="p-1">{{volunteerTaskPoint.callsPlacedCnt}} of
                {{volunteerTaskPoint.targetCallCnt??config.defaults.call.count}} calls
              </span>
              </div>
            </td>
          </tr>
          <tr>
            <th>Last Modified</th>
            <td>{{volunteerTaskPoint.modifiedByName}} @ {{volunteerTaskPoint.modifiedAt|date:'medium'}} </td>
          </tr>
          <tr>
            <th>Latitude, Longitude</th>
            <td>{{volunteerTaskPoint.latitude}}, {{volunteerTaskPoint.longitude}} </td>
          </tr>
          <tr>
            <th>Test Parameters</th>
            <td class="d-flex flex-wrap align-items-center">
              <app-volunteer-task-point-test-params #testParams
                [taskPoint]="volunteerTaskPoint"
                [config]="config">
              </app-volunteer-task-point-test-params>
            </td>
          </tr>
          <tr>
            <th>QR</th>
            <td>
              <app-point-qr-code [pointId]="volunteerTaskPoint['pointId']"></app-point-qr-code>
            </td>
          </tr>
        </table>
      </div>
      <div class="noprint d-flex flex-row justify-content-between">
        <a href="javascript:false;" (click)="onRefresh()"
        [ngClass]="loading&&'disabled'">
        <i class="fas fa-sync"></i>&nbsp;Refresh
        </a>
        <button class="btn btn-secondary btn-sm"
          printSectionId="printableVolunteerPoint"  [useExistingCss]="true" ngxPrint>
          <i class="fa fa-print mr-1"></i> Print
        </button>
      </div>
  </div>

  <div class="w-100" *ngIf="volunteerTaskPoint">
    <div class="mx-4 mb-2 mt-0 p-2 card">
      <table class="table table-sm my-0">
        <tr>
          <th role="button" (click)="callLogVisible=!callLogVisible" style="width: 10em;">
            Call Log
            <i class="ml-1 fa {{callLogVisible?'fa-chevron-down':'fa-chevron-right'}}"></i>
          </th>
          <td>
            <div class="d-flex flex-row justify-content-between">
              <div class="text-secondary font-italic small">
                <ng-container *ngIf="volunteerTaskPoint.lastCallTime">
                  {{lastCallMsg}}
                </ng-container>
              </div>
              <i class="fa fa-list text-primary" role="button" (click)="onShowRutLog()"></i>
            </div>
          </td>
        </tr>
      </table>
      <app-rut-call-log #rutCallLog class="mt-1" *ngIf="callLogVisible"
        [alternateViewsEnabled]="false"
        [loadOnInit]="true"
        [contextJson]="rutCallLogContext"
        (rowMouseOverEmitter)="rutRowHover($event,true)"
        (rowMouseOutEmitter)="rutRowHover($event,false)">
      >
      </app-rut-call-log>
    </div>
    <div class="mx-4 mb-2 mt-0 p-2 card">
      <table class="table table-sm my-0">
        <tr>
          <th role="button" (click)="toggleCorrelationVisible()" style="width: 10em;">
            Correlation
            <i class="ml-1 fa {{correlationVisible?'fa-chevron-down':'fa-chevron-right'}}"></i>
          </th>
          <td>
            <div class="d-flex flex-row justify-content-between">
              <div class="text-secondary font-italic small">
              </div>
              <i class="fa fa-list text-primary" role="button" (click)="onShowCorrelation()"></i>
            </div>
          </td>
        </tr>
      </table>
      <ng-container *ngIf="!refreshing&&correlationVisible">
        <ng-template #correlationCellRendererTmpl let-record="record" let-column="column"
            let-tableComponent="tableComponent" let-showRequestFn="showRequestFn">
          <td fes-correlation-table-cell-renderer [record]="record" [column]="column" [tableComponent]="tableComponent" (showRequest)="showRequestFn($event)">
          </td>
        </ng-template>
        <app-correlation-table #correlationTable class="mt-1"
          [alternateViewsEnabled]="false"
          (recordsLoaded)="onCorrelationRecordsLoaded($event)"
          [loadOnInit]="true"
          [contextJson]="correlationContext"
          [cellRendererTmplRef]="correlationCellRendererTmpl"
          (rowMouseOverEmitter)="correlationRowHover($event,true)"
          (rowMouseOutEmitter)="correlationRowHover($event,false)"
          >
        </app-correlation-table>
      </ng-container>
    </div>
  </div>

    <div class="mx-4 mb-4 p-2 card" *ngIf="!!scoutInfo">
      <div class="d-flex flex-row">
        <div class="pl-2" style="min-width: 300px" class="disabled">
          <app-scout-point-editor
            [isEditing]="false"
            [scoutPoints]="scoutInfo.scoutPath?.scoutPoints"
            [scoutPoint]="scoutInfo.scoutPoint"
            [showTitlebar]="true"
            [showErrorCalcFields]="true"
            [locked]="true"
          >
          </app-scout-point-editor>
        </div>
        <div class="d-table ml-2">
          <app-scout-point-photo-links
            *ngIf="scoutInfo"
            [uiLocked]="true"
            [scoutPoint]="scoutInfo.scoutPoint"
            [bShowPhotoSummary]="true"
            [scoutTask]="scoutInfo.scout"
            [scoutPath]="scoutInfo.scoutPath"
            [photoBtnContentTmplRef]="photoBtnContentTmpl"
            [bindContextFn]="bindMobilePhotoContextForTaskPoint(volunteerTaskPoint)"
            (photoIconDblClick)="toggleMobilePhotoForTaskPoint(volunteerTaskPoint)($event)"
            (contextBound)="photosContextBound($event)"
          ></app-scout-point-photo-links>
          <ng-template #photoBtnContentTmpl let-photo="photo" let-grpDef="grpDef" let-context="context">
            <i class="fa" [ngClass]="context?.iconCssClass"
              [ngStyle]="{'background-color': 'rgb(255,255,0,'+photo['bgAlpha']+')'}"
              [title]="context|json"></i>
          </ng-template>
        </div>
      </div>
      <div>
        <div *ngIf="isLoadingPhotos" class="busy-overlay-parent p-5">
          <div class="font-weight-bold busy-overlay">
            <i class="fa fa-spinner fa-spin"></i>&nbsp;Searching for photos...
          </div>
        </div>
        <div
          class="d-flex flex-column flex-wrap"
          [ngStyle]="{ display: isLoadingPhotos ? 'none' : 'initial' }"
        >
          <div
            class="ref-measurements-titlebar w-100"
            [ngStyle]="{ 'background-color': scoutInfo.scoutPoint?.color }"
          >
            <div class="d-flex flex-row justify-content-between">
              <div class="flex-grow-1">Mobile Accessible Photos</div>
            </div>
          </div>

          <div class="px-2 row">
            <ng-container *ngFor="let photo of photoDocs; index as index">
              <div
                *ngIf="contextByPhotoId[photo._id]?.isVisibleByMobileUser"
                class="px-sm-2 col-md-12 col-lg-6"
              >
                <app-scout-point-photo-editor
                  [scoutTaskDoc]="scoutInfo.scout"
                  [scoutPathId]="scoutInfo.scoutPath?.id"
                  [scoutPoint]="scoutInfo.scoutPoint"
                  [scoutPhoto]="photo"
                  [locked]="true"
                  [groupName]="'wide-angle'"
                  [editableDescription]="false"
                  [photoClickHandler]="onPhotoClick"
                >
                </app-scout-point-photo-editor>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div class="map-container">
    <app-volunteer-task-map
        #taskMap
        [volunteerTask]="task"
        [selectedMapPoint]="mapPoint"
        (pointSelected)="onMapPointSelected($event)"
        [mapPoints]="mapPoints"
        [bAllowPointSelection]="true"
        [miscLeafNodeEventFn]="onMiscLeafNodeEvent"
        [bInfoMarkersVisible]="!correlationVisible"
      >
      </app-volunteer-task-map>
    <app-map-point-summary [mapPoint]="mapPoint"> </app-map-point-summary>
  </div>
</div>
